define( [ "./selector-sizzle" ], function() {
	"use strict";
} );



//////////////////
// WEBPACK FOOTER
// ./node_modules/jquery/src/selector.js
// module id = rYQx
// module chunks = 0 1